package com.appsyde.shared.presentation.style.style

import com.appsyde.shared.presentation.style.token.AppStylesTokens
import org.jetbrains.compose.web.css.*

object AppStylesHistory : StyleSheet() {

    val historyToggleWrap by style {
            width(100.percent)
            display(DisplayStyle.Flex)
            justifyContent(JustifyContent.Center)
            marginBottom(10.px)
        }

        val historyToggleButton by style {
            display(DisplayStyle.Flex)
            alignItems(AlignItems.Center)
            gap(10.px)
            borderRadius(999.px)
            padding(10.px, 14.px)

            backgroundColor(rgba(255, 255, 255, 0.82))
            border(1.px, LineStyle.Solid, rgba(15, 23, 42, 0.08))
            color(rgba(15, 23, 42, 0.74))

            fontSize(12.8.px)
            fontWeight(650)
            property("letter-spacing", "-0.006em")
            property("box-shadow", "inset 0 1px 0 rgba(255,255,255,0.94), 0 10px 22px rgba(15,23,42,0.035)")
            cursor("pointer")
            property("user-select", "none")
            property("transition", "transform 130ms ease, box-shadow 130ms ease, border-color 130ms ease, background 130ms ease, color 130ms ease")

            self + hover style {
                property("transform", "translateY(-1px)")
                backgroundColor(rgba(255, 255, 255, 0.92))
                property("border-color", "rgba(102,96,230,0.16)")
                property("box-shadow", "inset 0 1px 0 rgba(255,255,255,0.96), 0 14px 28px rgba(15,23,42,0.05)")
                color(rgba(15, 23, 42, 0.82))
            }

            self + active style {
                property("transform", "translateY(0px)")
            }

            self + disabled style {
                opacity(0.55)
                cursor("not-allowed")
                property("transform", "none")
            }
        }

        val historyToggleIconPill by style {
            width(30.px)
            height(30.px)
            borderRadius(999.px)
            display(DisplayStyle.Flex)
            alignItems(AlignItems.Center)
            justifyContent(JustifyContent.Center)

            backgroundColor(rgba(102, 96, 230, 0.07))
            property("border", "1px solid rgba(102,96,230,0.13)")
            color(rgba(102, 96, 230, 0.88))

            fontSize(14.px)
            fontWeight(900)
            flexShrink(0)
        }
        val historyCollapseButton by style {
            backgroundColor(Color("rgba(15, 16, 35, 0.05)"))
            border {
                style(LineStyle.Solid)
                width(1.px)
                color(Color("rgba(15, 16, 35, 0.10)"))
            }
            borderRadius(999.px)
            padding(6.px, 10.px)
            fontSize(12.px)
            cursor("pointer")
            property("appearance", "none")
            property("touch-action", "manipulation")
        }

        val historyToggleTextCol by style {
            display(DisplayStyle.Flex)
            flexDirection(FlexDirection.Column)
            gap(1.px)
            minWidth(0.px)
        }

        val historyToggleTitle by style {
            fontSize(12.8.px)
            fontWeight(720)
            color(rgba(15, 23, 42, 0.80))
            whiteSpace("nowrap")
        }

        val historyToggleSubtitle by style {
            fontSize(11.6.px)
            fontWeight(560)
            color(rgba(15, 23, 42, 0.48))
            whiteSpace("nowrap")
        }

        // ----------------------------
        // Panel “Historique”
        // ----------------------------




        // ----------------------------
        // Chips / states
        // ----------------------------
        val historyErrorChip by style {
            borderRadius(999.px)
            padding(8.px, 12.px)
            fontSize(12.5.px)
            fontWeight(650)
            backgroundColor(rgba(200, 55, 80, 0.07))
            color(rgba(200, 55, 80, 0.85))
            border(1.px, LineStyle.Solid, rgba(200, 55, 80, 0.16))
        }

        val historyLoadingDot by style {
            opacity(0.55)
        }

        val historyBadge by style {
            borderRadius(999.px)
            padding(6.px, 10.px)
            fontSize(11.4.px)
            fontWeight(650)

            backgroundColor(rgba(102, 96, 230, 0.08))
            color(rgba(102, 96, 230, 0.86))
            border(1.px, LineStyle.Solid, rgba(102, 96, 230, 0.14))
            property("letter-spacing", "-0.006em")
        }

        val historyPanelHeaderLeft by style {
            display(DisplayStyle.Flex)
            alignItems(AlignItems.Center)
            gap(8.px)
        }
        val historySeparatorWrap by style {
            width(100.percent)
            display(DisplayStyle.Flex)
            alignItems(AlignItems.Center)
            justifyContent(JustifyContent.Center)
            gap(10.px)
            margin(18.px, 0.px, 10.px, 0.px)
        }

        val historySeparatorLine by style {
            height(1.px)
            width(38.percent)
            backgroundColor(rgba(15, 23, 42, 0.06))
        }

        val historySeparatorText by style {
            fontSize(11.6.px)
            fontWeight(650)
            color(rgba(15, 23, 42, 0.42))
            property("letter-spacing", "-0.004em")
            whiteSpace("nowrap")
            property("user-select", "none")
        }
        val historyPanelWrap by style {
            position(Position.Relative)
            width(100.percent)
        }

        val historyToggleOverlay by style {
            position(Position.Absolute)
            top(0.px)
            left(50.percent)
            property("transform", "translate(-50%, -50%)")
            property("z-index", "5")
        }
        // ------------------------------------------------------------
// History header actions (right side)
// ------------------------------------------------------------


        // ------------------------------------------------------------
// Mode switch: "Résumé" / "Originaux"
// Compact segmented control
// ------------------------------------------------------------




        val historyErrorInline by style {
            marginTop(8.px)
            padding(10.px, 12.px)
            borderRadius(12.px)
            backgroundColor(Color("rgba(255, 80, 80, 0.08)"))
            color(Color("rgba(160, 30, 30, 0.95)"))
            fontSize(13.px)
        }


        val historyPanelKicker by style {
            fontSize(11.2.px)
            fontWeight(650)
            color(Color("rgba(20, 22, 35, 0.55)")) // ✅ neutre (plus violet)
            property("letter-spacing", "-0.004em")
            whiteSpace("nowrap")
            property("textTransform", "uppercase")
        }

        val historyModeSwitch by style {
            display(DisplayStyle.LegacyInlineFlex)
            alignItems(AlignItems.Center)
            gap(0.px)

            // Le "rail" : visible mais très doux
            backgroundColor(Color("rgba(15, 16, 35, 0.05)"))
            border {
                style(LineStyle.Solid)
                width(1.px)
                color(Color("rgba(15, 16, 35, 0.10)"))
            }
            borderRadius(999.px)
            padding(3.px)

            property("user-select", "none")
            property("-webkit-tap-highlight-color", "transparent")
        }
        val historyCollapsedWrap by style {
            // évite l’effet "collé au body"
            marginBottom(12.px)

            // choix: aligné à gauche (reco)
            display(DisplayStyle.Flex)
            justifyContent(JustifyContent.FlexStart)
        }
        val historyPanelHeaderCollapsed by style {
            backgroundColor(Color.transparent)
            paddingBottom(6.px)
        }

        val historyCollapsedChip by style {
            display(DisplayStyle.LegacyInlineFlex)
            alignItems(AlignItems.Center)
            gap(8.px)

            padding(10.px, 12.px)
            borderRadius(999.px)

            backgroundColor(Color("rgba(255,255,255,0.70)"))
            border {
                style(LineStyle.Solid)
                width(1.px)
                color(Color("rgba(15, 16, 35, 0.10)"))
            }

            fontSize(13.px)
            fontWeight(600)
            color(Color("rgba(20, 22, 45, 0.82)"))

            cursor("pointer")
            property("appearance", "none")
            property("touch-action", "manipulation")
            property("-webkit-tap-highlight-color", "transparent")
            property("box-shadow", "0 10px 26px rgba(10,12,22,0.06)")
        }

        val historyCollapsedChevron by style {
            width(22.px)
            height(22.px)
            borderRadius(999.px)

            display(DisplayStyle.Flex)
            alignItems(AlignItems.Center)
            justifyContent(JustifyContent.Center)

            backgroundColor(Color("rgba(15, 16, 35, 0.06)"))
            border {
                style(LineStyle.Solid)
                width(1.px)
                color(Color("rgba(15, 16, 35, 0.08)"))
            }
            fontSize(12.px)
        }

        val historyCollapsedText by style {
            // rien, mais garde pour tuning
        }

        val historyCollapsedDot by style {
            color(Color("rgba(20, 22, 45, 0.35)"))
            fontWeight(700)
        }

        val historyCollapsedCount by style {
            color(Color("rgba(20, 22, 45, 0.60)"))
            fontWeight(600)
        }

        val historyCollapsedBar by style {
            display(DisplayStyle.Flex)
            alignItems(AlignItems.Center)
            justifyContent(JustifyContent.SpaceBetween)

            // compact
            padding(12.px, 14.px)
            borderRadius(16.px)

            // très léger, comme tes autres cards
            backgroundColor(Color("rgba(255,255,255,0.65)"))
            border {
                style(LineStyle.Solid)
                width(1.px)
                color(Color("rgba(15, 16, 35, 0.08)"))
            }
        }

        val historyChevronButton by style {
            backgroundColor(Color("rgba(15, 16, 35, 0.05)"))
            border {
                style(LineStyle.Solid)
                width(1.px)
                color(Color("rgba(15, 16, 35, 0.10)"))
            }
            borderRadius(999.px)
            padding(6.px, 10.px)
            fontSize(12.px)
            cursor("pointer")
            property("appearance", "none")
            property("touch-action", "manipulation")
            property("-webkit-tap-highlight-color", "transparent")
        }

        val historyModeButton by style {
            backgroundColor(Color.transparent)
            border(0.px)
            borderRadius(999.px)

            padding(6.px, 10.px)
            fontSize(12.px)
            fontWeight(600)

            // lisible sur fond clair
            color(Color("rgba(20, 22, 45, 0.65)"))

            cursor("pointer")
            property("touch-action", "manipulation")
            property("appearance", "none")
            property("white-space", "nowrap")

            // petit effet "calme" au hover/focus (bonus desktop)
            property("transition", "background-color 120ms ease, color 120ms ease")
        }

        val historyModeButtonActive by style {
            // Le "thumb" actif
            backgroundColor(Color("rgba(255,255,255,0.90)"))
            color(Color("rgba(20, 22, 45, 0.92)"))
            border {
                style(LineStyle.Solid)
                width(1.px)
                color(Color("rgba(15, 16, 35, 0.12)"))
            }

            // micro-shadow doux (fait toute la diff)
            property("box-shadow", "0 6px 18px rgba(10,12,22,0.08)")
        }

        val historyFloatingWrap by style {
            // ✅ aligné à droite, largeur auto
            display(DisplayStyle.Flex)
            justifyContent(JustifyContent.FlexEnd)

            // ✅ respiration avant le contenu suivant
            marginBottom(12.px)
        }

        val historyFloatingPill by style {
            display(DisplayStyle.LegacyInlineFlex)
            alignItems(AlignItems.Center)
            gap(8.px)

            padding(10.px, 12.px)
            borderRadius(999.px)

            backgroundColor(Color("rgba(255,255,255,0.75)"))
            border {
                style(LineStyle.Solid)
                width(1.px)
                color(Color("rgba(15, 16, 35, 0.10)"))
            }

            fontSize(13.px)
            fontWeight(600)
            cursor("pointer")
            property("appearance", "none")
            property("touch-action", "manipulation")
            property("-webkit-tap-highlight-color", "transparent")
            property("box-shadow", "0 10px 26px rgba(10,12,22,0.06)")
        }

        val historyFloatingLabel by style {
            color(Color("rgba(20, 22, 45, 0.85)"))
            whiteSpace("nowrap")
        }

        val historyFloatingDot by style {
            color(Color("rgba(20, 22, 45, 0.35)"))
            fontWeight(700)
        }

        val historyFloatingCount by style {
            color(Color("rgba(20, 22, 45, 0.62)"))
            fontWeight(600)
            whiteSpace("nowrap")
        }

        val historyFloatingChevron by style {
            // ✅ chevron "ancré" visuellement à droite
            marginLeft(4.px)
            width(22.px)
            height(22.px)
            borderRadius(999.px)
            display(DisplayStyle.Flex)
            alignItems(AlignItems.Center)
            justifyContent(JustifyContent.Center)
            backgroundColor(Color("rgba(15, 16, 35, 0.06)"))
            border {
                style(LineStyle.Solid)
                width(1.px)
                color(Color("rgba(15, 16, 35, 0.08)"))
            }
            fontSize(12.px)
        }

        // ----------------------------
// Panel “Historique” (ASSUMÉ)
// ----------------------------
        // ============================
// HISTORY PANEL (SIMPLE)
// ============================

        val historyPanel by style {
            width(100.percent)
            borderRadius(16.px)
            padding(14.px)
            marginBottom(14.px)

            //backgroundColor(Color("rgba(248, 249, 252, 0.92)"))
           /* border {
                style(LineStyle.Solid)
                width(1.px)
                color(Color("rgba(15, 16, 35, 0.08)"))
            }*/

            // ✅ une seule ombre (très soft), pas d'empilement
            property("box-shadow", "inset 0 1px 0 rgba(255,255,255,0.86)")
        }

        val historyPanelHeader by style {
            display(DisplayStyle.Flex)
            alignItems(AlignItems.FlexStart)
            justifyContent(JustifyContent.SpaceBetween)
            marginBottom(12.px)
        }

        val historyHeaderLeft by style {
            display(DisplayStyle.Flex)
            flexDirection(FlexDirection.Column)
            gap(2.px)
            minWidth(0.px)
        }

        val historyPanelTitle by style {
            fontSize(13.px)
            fontWeight(720)
            color(Color("rgba(20, 22, 35, 0.86)"))
        }

        val historyPanelHint by style {
            fontSize(11.6.px)
            fontWeight(560)
            color(Color("rgba(20, 22, 35, 0.46)"))
        }

        // Right side actions
        val historyPanelActions by style {
            display(DisplayStyle.Flex)
            alignItems(AlignItems.Center)
            gap(10.px)
        }

        // "Masquer" discret
        val historyCloseButton by style {
            display(DisplayStyle.Flex)
            alignItems(AlignItems.Center)
            gap(6.px)

            padding(7.px, 10.px)
            borderRadius(999.px)
            backgroundColor(Color("rgba(15, 16, 35, 0.04)"))
            border {
                style(LineStyle.Solid)
                width(1.px)
                color(Color("rgba(15, 16, 35, 0.08)"))
            }

            fontSize(12.px)
            fontWeight(650)
            color(Color("rgba(20, 22, 45, 0.66)"))

            cursor("pointer")
            property("appearance", "none")
            property("touch-action", "manipulation")
            property("-webkit-tap-highlight-color", "transparent")
            property("transition", "background-color 140ms ease, border-color 140ms ease, color 140ms ease")

            self + hover style {
                backgroundColor(Color("rgba(15, 16, 35, 0.06)"))
                property("border-color", "rgba(102,96,230,0.14)")
                color(Color("rgba(70, 78, 220, 0.85)"))
            }
        }

// ============================
// TIMELINE LIST (NO CARDS)
// ============================

        val historyList by style {
            position(Position.Relative)
            display(DisplayStyle.Flex)
            flexDirection(FlexDirection.Column)
            gap(12.px)
            paddingLeft(14.px)

            // ✅ ligne verticale très fine
            property("border-left", "1px solid rgba(15,16,35,0.08)")
        }

        val historyItemWrap by style {
            position(Position.Relative)
            paddingLeft(12.px)
        }

        val historyDot by style {
            position(Position.Absolute)
            left((-7).px)
            top(10.px)

            width(10.px)
            height(10.px)
            borderRadius(999.px)

            backgroundColor(Color("rgba(102,96,230,0.32)"))

            border {
                style(LineStyle.Solid)
                width(1.px)
                color(Color("rgba(102,96,230,0.72)"))

            }
        }

        // Un “bloc” contenu léger (si tu veux wrapper les bulles)
        val historyContentWrap by style {
            borderRadius(14.px)
            padding(10.px, 12.px)

           // backgroundColor(Color("rgba(255,255,255,0.55)"))
          /*  border {
                style(LineStyle.Solid)
                width(1.px)
                color(Color("rgba(15,16,35,0.06)"))
            } */

            // ✅ aucune ombre ici
        }



        val historyCloseText by style {
            whiteSpace("nowrap")
        }

        val historyCloseChevron by style {
            fontSize(12.px)
            opacity(0.70)
        }
    }


